// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"6c7a0aad","174":"28d5335d","400":"1eec3745","453":"6ded72a1","507":"47431824","949":"3b01fe34"}[chunkId] + ".chunk.js";
};